import { Box, Flex, Heading } from "@chakra-ui/react";
import { ObjectFieldTemplateProps } from "@rjsf/utils";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { CustomUiSchemaOptions } from "../../../form-ui-options";

export const CustomObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const { description, uiSchema } = props;
  const isRoot = props.idSchema.$id === "root";

  const addElement = (uiSchema as CustomUiSchemaOptions | undefined)?.["ui:addElement"];

  return (
    <Box
      display="grid"
      gridGap={6}
      sx={{
        "*[data-disabled]": { opacity: "1 !important" },
        "*[disabled]": { opacity: "1 !important" },
      }}
    >
      <Heading as={isRoot ? "h2" : "h4"} size={isRoot ? "xl" : "lg"}>
        {props.title}
      </Heading>
      {description && (
        <Box textStyle="sm" fontWeight="light" color="gray.700">
          <Markdown
            remarkPlugins={[remarkGfm]}
            components={{
              /* Open links in new tab */
              a: ({ children, ...props }) => (
                <a
                  target="_blank"
                  style={{ color: "blue", textDecoration: "underline" }}
                  {...props}
                >
                  {children}
                </a>
              ),
            }}
          >
            {description}
          </Markdown>
        </Box>
      )}
      <Flex gap={6}>
        <Flex flexDirection={isRoot ? "column" : "row"} gap={6} flexWrap="wrap" w="full">
          {props.properties.map((element) => element.content)}
        </Flex>
        {addElement && (
          <Box h="fit-content" top={10} position="sticky">
            {addElement}
          </Box>
        )}
      </Flex>
    </Box>
  );
};
